import Vue from 'vue';
import Shipment from './Shipment';
import './money';

new Vue({
  el: '#checkout',

  mixins: [Shipment],

  data: window?.Contraversus?.cart || {},

  computed: {
    /**
     * Get the cart total.
     *
     * @returns {number}
     */
    total() {
      return this.subtotal + this.fee;
    },

    /**
     * Check if the order can be shipped on saturday.
     *
     * @returns {boolean}
     */
    canShipOnSaturday() {
      return this.shipment.destination === 'customer';
    },

    /**
     * Check if the order can be delivered the same day.
     *
     * @returns {boolean}
     */
    canShipOnSameDay() {
      return this.store.slug === 'bonadiva';
    },

    /**
     * Check if the order does not need an address.
     *
     * @returns {boolean}
     */
    withoutAddress() {
      return this.shipment.destination === 'store';
    },
  },

  watch: {
    /**
     * Uncheck ship on saturday if the order cannot be shipped on saturday.
     */
    'shipment.destination': function (destination) {
      if (destination !== 'customer') {
        this.shipment.shipOnSaturday = false;
      }
    },

    /**
     * Uncheck same day deliver if ship on saturday is checked.
     */
    'shipment.shipOnSaturday': function (shipOnSaturday) {
      if (shipOnSaturday) {
        this.shipment.sameDayDelivery = false;
      }
    },
  },

  methods: {
    /**
     * Update the shipment address.
     *
     * @param {string} name
     * @param {Event} e
     */
    updateAddress(name, e) {
      this.shipment.address[name] = e.target.value;
    },

    /**
     * Update payment methods when the shipment destination changes.
     */
    destinationChanged() {
      this.updatePaymentMethods();
    },

    /**
     * Fetch the shipment methods according to the destination.
     */
    updatePaymentMethods() {
      let $paymentMethods = $(this.$el).find('#payment_methods');

      $.post('/order/checkout/payment-methods', {
        payment: {
          method_id: $paymentMethods.find('[name="payment[method_id]"]:checked').val(),
        },
        shipment: {
          destination: this.shipment.destination,
        }
      }).done(response => {
        $paymentMethods.replaceWith(response);
      });
    },
  },
});
